import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from "../utils/uiUtils";
import UserAdminListView from "./UserAdminListView";
import UserAdminNewView from "./UserAdminNewView";
import UserAdminDetailsView from "./UserAdminDetailsView";

const UserAdmin = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  // const location = useLocation();

  // The existance of location.state indicated a redirect from the Manage Admin
  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode("LIST");

  const PAGE_STATE_STORAGE_KEY = "UserAdmin.pageState";
  const defaultPageState = {
    searchField: "Name",
    searchTerms: null,
    searchDeptId: null,
    searchStatus: "USR_ST_ACTIVE",
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {
    // Route to home page if not authorized
    if (
      !hasAnyPerm(
        user,
        ["UserAdminWriteAccess", "OrgAdminGeneralWriteAccess"],
        true
      )
    ) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: "Dashboard",
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      {uiMode === "LIST" ? (
        <UserAdminListView
          pageState={pageState}
          onUIMode={setUIMode}
          onSetPageState={setPageState}
          onSetObjDetails={setObjDetails}
        />
      ) : null}
      {uiMode === "DETAILS" ? (
        <UserAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />
      ) : null}
      {uiMode === "NEW" ? <UserAdminNewView onUIMode={setUIMode} /> : null}
    </Fragment>
  );
};

export default UserAdmin;
